import { render } from "./price-list.vue?vue&type=template&id=fb3b8716&scoped=true"
import script from "./price-list.vue?vue&type=script&lang=js"
export * from "./price-list.vue?vue&type=script&lang=js"

import "./price-list.vue?vue&type=style&index=0&id=fb3b8716&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3b8716"]])

export default __exports__